import styled from 'styled-components';
import { FormControl, TextField } from '@mui/material';

import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';

export const PillFormControl = styled(FormControl)`
  width: 240px;

  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
  }
`;

export const PillTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border-radius: 30px;
    background-color: white;
    box-sizing: border-box;
    height: 50px;
    padding: 15px 5px;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: rgba(234, 234, 235, 0.9);
    border-width: 2px;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${colours.neutral[300]};
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${colours.neutral[400]};
  }

  .MuiOutlinedInput-input {
    padding-top: 15px;
    padding-bottom: 15px;
  }
`;
